var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yd-table-footer flex-1 color-bg-fff" },
    [
      _vm.list.length > 0
        ? _c(
            "el-table",
            _vm._g(
              _vm._b(
                {
                  ref: "footerTableRef",
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: _vm.tableSize,
                    "show-header": false,
                    border: _vm.tableBorder,
                    stripe: _vm.stripe,
                    data: _vm.list,
                    "row-key": _vm.rowKey,
                  },
                },
                "el-table",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            ),
            [
              _vm._l(_vm.renderColumns, function (item) {
                return [
                  item.children && item.children.length > 0
                    ? [
                        _c("TableCOlumnItem", {
                          key: item.prop,
                          attrs: { item: item },
                        }),
                      ]
                    : _c(
                        "el-table-column",
                        _vm._b(
                          {
                            key: item.prop,
                            scopedSlots: _vm._u(
                              [
                                item.tips
                                  ? {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _c("TableColumnTip", {
                                            attrs: {
                                              align: item.align,
                                              label: item.label,
                                              content: item.tips,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                item.prop === "sortIndex"
                                  ? {
                                      key: "default",
                                      fn: function (ref) {
                                        var $index = ref.$index
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.index + $index + 1)
                                            ),
                                          ]),
                                        ]
                                      },
                                    }
                                  : {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _vm._t(
                                            item.prop,
                                            function () {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "content" },
                                                  [
                                                    _vm._v(
                                                      "\n              " +
                                                        _vm._s(row[item.prop]) +
                                                        "\n            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            { item: row }
                                          ),
                                        ]
                                      },
                                    },
                              ],
                              null,
                              true
                            ),
                          },
                          "el-table-column",
                          item,
                          false
                        )
                      ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c("ScrollBox", {
        attrs: {
          scrollLeft: _vm.scrollLeft,
          tableWidth: _vm.tableWidth,
          setScrollLeft: _vm.setScrollLeft,
        },
      }),
      _c("Pagination", {
        attrs: { initPages: _vm.pageState },
        scopedSlots: _vm._u(
          [
            _vm._l(
              Object.keys(Object.assign({}, _vm.$scopedSlots, _vm.$slots)),
              function (slot) {
                return {
                  key: slot,
                  fn: function (scope) {
                    return [_vm._t(slot, null, null, scope)]
                  },
                }
              }
            ),
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }